<template>
  <div class="chat__reactions" v-click-outside="closeReactions">
    <div class="chat__reactions__reactions" :class="{active: showReact}">
      <ul class="emoji-list current align-items-center" v-if="totalReactions" @click="activateReactions">
        <li v-for="(emoji, name) in emojis" :key="name" class="minimised-reactions">
          <img :src="emoji.icon"
               :class="{reacted: emoji.ifReacted}"
               v-if="emoji.reactionsNo"
          />
        </li>
        <li>
          <span class="total-reactions-no padding-sm-left"
            ><small> <b>{{ totalReactions }}</b></small></span
          >
        </li>
      </ul>
      <div class="react-options">
        <img src="@/assets/chat-icons/like.svg"  alt="react to chat message" @click="activateReactions" />
        <img src="@/assets/chat-icons/reply.svg"  alt="reply to chat message" @click="replyToMessage" />
      </div>
    </div>
    <div class="chat__reactions__action" v-if="showReact">
      <ul class="emoji-list__action align-items-center">
        <li v-for="(emoji, name) in emojis" :key="name">
          <img :src="emoji.icon"
               :class="{reacted: emoji.ifReacted}"
               @click="() => toggleReactionHandler({name, state: emoji.ifReacted})"
          />
          <p class="emoji-count text-center p-0 m-0">
            <small><b> {{ emoji.reactionsNo }}</b></small>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChatReactions',
  props: {
    messageId: String,
    reactions: Array,
    totalReactions: Number,
    replyToMessage: Function,
  },
  data: () => ({
    emojis: {
      love: {
        icon: require('@/assets/chat-icons/reactions/heart.svg'),
        reactionsNo: 0,
        ifReacted: false,
        lastUpdated: 0
      },
      like: {
        icon: require('@/assets/chat-icons/reactions/ok.svg'),
        reactionsNo: 0,
        ifReacted: false,
        lastUpdated: 0
      },
      smile: {
        icon: require('@/assets/chat-icons/reactions/smile.svg'),
        reactionsNo: 0,
        ifReacted: false,
        lastUpdated: 0
      },
      surprised: {
        icon: require('@/assets/chat-icons/reactions/astonished.svg'),
        reactionsNo: 0,
        ifReacted: false,
        lastUpdated: 0
      },
      celebrate: {
        icon: require('@/assets/chat-icons/reactions/celebrate.svg'),
        reactionsNo: 0,
        ifReacted: false,
        lastUpdated: 0
      }
    },
    showReact: false,
  }),
  watch: {
    reactions() {
      this.calcReactionCounts()
    }
  },
  methods: {
    ...mapActions(['reactToChatMessageHandler', 'analytics/reactToChatMessage']),
    activateReactions() {
      this.showReact = !this.showReact;
    },
    closeReactions() {
      this.showReact = false;
    },
    calcReactionCounts() {
      this.reactions.forEach(item => {
        this.emojis[item.reactionName].ifReacted = item.userReacted
        this.emojis[item.reactionName].reactionsNo = item.totalReactions
      })
    },
    async toggleReactionHandler({name,state}) {
      //check last click
      let lastUpdated = this.emojis[name].lastUpdated
      if(!lastUpdated || lastUpdated < (Date.now() - 500)) {
        let res = await this.reactToChatMessageHandler({
          messageId: this.messageId,
          reactionName: name,
          targetState: !state
        })
        if(res.success) {
          this['analytics/reactToChatMessage']([name, !state, this.messageId])
          //temporarily update until next api response
          this.emojis[name].ifReacted = !state
          this.emojis[name].lastUpdated = Date.now()
        }
        this.activateReactions()
      }
    }
  },
  mounted() {
    this.calcReactionCounts()
  }
};
</script>

<style lang="scss" scoped>
@import '~@/scss/components/sidebar/chat_reactions.scss';
</style>
